import * as yup from "yup";

export const newJournalSchema = yup.object().shape({
    journalTitle: yup.string().required('Title is required'),
    timeCapsuleConfiguration: yup.object().shape({
        deliveryDate: yup.string().required('Delivery date is required'),
        closeContacts: yup.array().of( yup.object().shape({
            email: yup.string().email().required('Email is required'),
            relationship: yup.string().required('Relatinship is required')
        }))
    })
});